{
  "home": {
    "title": "Merchant App Host",
    "welcome": "Welcome. Network applications mount their routes into this shell."
  }
}
